var _circle, _path, _circle2, _circle3, _circle4, _path2, _circle5, _circle6, _g, _circle7, _circle8, _path3, _path4, _circle9, _path5, _circle10, _circle11, _circle12, _path6, _circle13, _circle14, _g2, _circle15, _circle16, _path7, _path8, _circle17, _path9, _circle18, _circle19, _circle20, _path10, _circle21, _circle22, _g3, _circle23, _circle24, _path11, _path12, _circle25, _path13, _circle26, _circle27, _circle28, _path14, _circle29, _circle30, _g4, _circle31, _circle32, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 87,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FF6969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.48 22.042c0 7.958-6.683 11.625-11.74 11.625S8 29.667 8 22.042C8 14.69 13.894 9.034 17.33 6.36c1.424-1.108 3.367-1.062 4.758.088 3.426 2.833 9.392 8.749 9.392 15.593Z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.741,
    cy: 22.58,
    r: 9.333,
    fill: "#FFEDE8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2,
    cy: 22.714,
    r: 0.672,
    fill: "#503917"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.907,
    cy: 22.714,
    r: 0.672,
    fill: "#503917"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.234 24.432a1.72 1.72 0 0 1-3.436 0h3.436Z",
    fill: "#FF6969"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.741,
    cy: 22.58,
    r: 9.333,
    fill: "#FFEDE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "group_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 13,
    width: 20,
    height: 19
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.741,
    cy: 22.58,
    r: 9.333,
    fill: "#FFE8E0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#group_svg__a)",
    fill: "#FED0C2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.797,
    cy: 26.333,
    r: 3.667
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.131,
    cy: 26.333,
    r: 3.667
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2,
    cy: 22.714,
    r: 0.672,
    fill: "#503917"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.906,
    cy: 22.714,
    r: 0.672,
    fill: "#503917"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.234 24.432a1.72 1.72 0 1 1-3.437 0H21.234Z",
    fill: "#FF6969"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.132 15.203c-.366-1.803 1.055-2.623 2.615-2.623 1.56 0 2.93.765 2.615 2.623-.072.326-.175.64-.298.937-.865 2.093-3.759 2.085-4.638-.002a4.955 4.955 0 0 1-.294-.935Z",
    fill: "#503917"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 67,
    r: 20,
    fill: "#FFEDE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.682 69.041c0 7.958-6.682 11.625-11.74 11.625-5.057 0-11.74-4-11.74-11.625 0-7.351 5.894-13.008 9.33-15.68 1.424-1.11 3.368-1.063 4.759.087 3.426 2.834 9.391 8.75 9.391 15.593Z",
    fill: "#FF6969"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.943,
    cy: 69.579,
    r: 9.333,
    fill: "#FFEDE8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.402,
    cy: 69.713,
    r: 0.672,
    fill: "#503917"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.109,
    cy: 69.713,
    r: 0.672,
    fill: "#503917"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.437 71.431a1.719 1.719 0 0 1-3.437 0H21.437Z",
    fill: "#FF6969"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.943,
    cy: 69.579,
    r: 9.333,
    fill: "#FFEDE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "group_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 60,
    width: 20,
    height: 19
  }, _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.943,
    cy: 69.579,
    r: 9.333,
    fill: "#FFE8E0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#group_svg__b)",
    fill: "#FED0C2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 73.332,
    r: 3.667
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.333,
    cy: 73.332,
    r: 3.667
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.402,
    cy: 69.713,
    r: 0.672,
    fill: "#503917"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.109,
    cy: 69.713,
    r: 0.672,
    fill: "#503917"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.437 71.431a1.719 1.719 0 0 1-3.437 0H21.437Z",
    fill: "#FF6969"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.335 62.202c-.366-1.803 1.055-2.623 2.615-2.623 1.56 0 2.929.765 2.615 2.623-.073.326-.175.64-.298.937-.866 2.094-3.76 2.085-4.638-.002a4.964 4.964 0 0 1-.294-.935Z",
    fill: "#503917"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 67,
    r: 20,
    fill: "#FF6969"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.48 69.041c0 7.958-6.683 11.625-11.74 11.625S56 76.666 56 69.041c0-7.351 5.894-13.008 9.33-15.68 1.424-1.11 3.367-1.063 4.758.087 3.426 2.834 9.392 8.75 9.392 15.593Z",
    fill: "#fff"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.741,
    cy: 69.579,
    r: 9.333,
    fill: "#FFEDE8"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.2,
    cy: 69.713,
    r: 0.672,
    fill: "#503917"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.906,
    cy: 69.713,
    r: 0.672,
    fill: "#503917"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.234 71.431a1.719 1.719 0 0 1-3.436 0h3.436Z",
    fill: "#FF6969"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.741,
    cy: 69.579,
    r: 9.333,
    fill: "#FFEDE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "group_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 60,
    width: 20,
    height: 19
  }, _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.741,
    cy: 69.579,
    r: 9.333,
    fill: "#FFE8E0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#group_svg__c)",
    fill: "#FED0C2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.797,
    cy: 73.332,
    r: 3.667
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.131,
    cy: 73.332,
    r: 3.667
  }))), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.2,
    cy: 69.713,
    r: 0.672,
    fill: "#503917"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.906,
    cy: 69.713,
    r: 0.672,
    fill: "#503917"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.234 71.431a1.719 1.719 0 0 1-3.436 0h3.436Z",
    fill: "#FF6969"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.132 62.202c-.366-1.803 1.055-2.623 2.615-2.623 1.56 0 2.93.765 2.615 2.623-.072.326-.175.64-.298.937-.865 2.094-3.759 2.085-4.638-.002a4.957 4.957 0 0 1-.294-.935Z",
    fill: "#503917"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 20,
    r: 20,
    fill: "#A0C89B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.682 22.041c0 7.958-6.682 11.625-11.74 11.625-5.057 0-11.74-4-11.74-11.625 0-7.351 5.894-13.008 9.33-15.68 1.424-1.11 3.368-1.063 4.759.087 3.426 2.834 9.391 8.75 9.391 15.593Z",
    fill: "#FF6969"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.943,
    cy: 22.579,
    r: 9.333,
    fill: "#FFEDE8"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.402,
    cy: 22.713,
    r: 0.672,
    fill: "#503917"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.109,
    cy: 22.713,
    r: 0.672,
    fill: "#503917"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.437 24.431a1.719 1.719 0 0 1-3.437 0H69.437Z",
    fill: "#FF6969"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.943,
    cy: 22.579,
    r: 9.333,
    fill: "#FFEDE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "group_svg__d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 13,
    width: 20,
    height: 19
  }, _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.943,
    cy: 22.578,
    r: 9.333,
    fill: "#FFE8E0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#group_svg__d)",
    fill: "#FED0C2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 26.332,
    r: 3.667
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.333,
    cy: 26.332,
    r: 3.667
  }))), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.402,
    cy: 22.713,
    r: 0.672,
    fill: "#503917"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.109,
    cy: 22.713,
    r: 0.672,
    fill: "#503917"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.437 24.431a1.719 1.719 0 0 1-3.437 0H69.437Z",
    fill: "#FF6969"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.335 15.202c-.366-1.803 1.055-2.623 2.615-2.623 1.56 0 2.929.765 2.615 2.623-.073.326-.175.64-.298.937-.866 2.094-3.76 2.085-4.638-.002a4.964 4.964 0 0 1-.294-.935Z",
    fill: "#503917"
  })));
};
export default SvgGroup;